import { Controller } from "@hotwired/stimulus"

/**
 * Balance Sheet Filters Controller
 *
 * Handles automatic date updates when fiscal year is selected.
 */
export default class extends Controller {
  static targets = ["fiscalYearSelect", "startDate", "endDate"]

  static values = {
    fiscalYears: Array
  }

  connect() {
    // Nothing to do on connect
  }

  // Update start and end dates when fiscal year changes
  updateDates(event) {
    const selectedId = parseInt(event.target.value)

    if (!selectedId) return

    const fiscalYear = this.fiscalYearsValue.find(fy => fy.id === selectedId)

    if (fiscalYear) {
      // Update start date
      if (this.hasStartDateTarget && fiscalYear.start_date) {
        this.updateDateField(this.startDateTarget, fiscalYear.start_date)
      }

      // Update end date
      if (this.hasEndDateTarget && fiscalYear.end_date) {
        this.updateDateField(this.endDateTarget, fiscalYear.end_date)
      }
    }
  }

  // Update a date field, handling Flatpickr if present
  updateDateField(field, dateValue) {
    // Check if Flatpickr is initialized on this field
    if (field._flatpickr) {
      // Parse the date (format: dd/mm/yyyy)
      const parts = dateValue.split('/')
      if (parts.length === 3) {
        const date = new Date(parts[2], parts[1] - 1, parts[0])
        field._flatpickr.setDate(date, true)
      }
    } else {
      field.value = dateValue
    }
  }
}
